import React, { useEffect } from 'react';
import { projectCss } from '../../../common/Css';
import UpdatePo from './UpdatePO';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { SkeltonCardTwo } from '../../../common/SkeltonCardTwo';
import { ScogoAmountBalance } from '../../Wallet/Modals/SendToBank';
import { DetailsToShow } from '../../Ticket/CloseFeasibility/Details';
import { getPOById } from '../../../actions/payments';
import { useNavigate, useParams } from 'react-router-dom';
import { isPayPOAllowed } from '../../../utils/access';

export default function RenderUpdatePo({ }) {
    const dispatch = useDispatch();
    const { poId } = useParams();
    const purchaseOrderDetails = useSelector((state) => state.payments.purchaseOrderDetails);
    const isPoByIdLoading = useSelector((state) => state.loading.isPoByIdLoading);
    const poData = purchaseOrderDetails && purchaseOrderDetails[poId] ? purchaseOrderDetails[poId] : {};
    const navigate = useNavigate();
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);

    useEffect(() => {
        dispatch(getPOById({ id: poId }));
    }, [dispatch, poId]);

    const title = poData.status === 'CANCELLED' ? 'Reopen PO' : 'Update PO';
    const identification = poData.pr_number || poData.external_po_number;

    return <>
        <div className={`subContainer title-4 p-5`}>
            <div className={`titleContainer`}>
                <div className='flex gap-2 items-center'>
                    <div
                        onClick={() => navigate(-1)}
                        className='hover:text-scogoorange hover:bg-white pr-2 py-1 hover:shadow-md text-scogoprimary cursor-pointer flex items-center text-font20  rounded-md'
                    >
                        <span className='material-icons  m-0 font-bold '>chevron_left</span>
                        <span className='m-0'>BACK</span>
                    </div>
                    <h1 className='text-scogo21 text-font16 font-medium font-rubik '>{title} : {<span className='text-scogobgsky text-font16'>{identification}</span>}</h1>
                    {isPayPOAllowed(newLoggedUserData.actions) && <div className='ml-auto flex-auto max-w-max'><ScogoAmountBalance /></div>}
                </div>
            </div>

            <DetailsToShow poData={poData} />
            <div className='flex-auto'>
                <div className='flex-auto '>
                    <div className='tab-content tab-space bg-white shadow-xl rounded-lg'>
                        <div className={`${projectCss?.scmAddProjectForm} lg:pb-0 md:pb-168 pb-230 overflow-auto mb-24 md:mb-24 `} style={{ height: '63vh' }}>
                            {(isPoByIdLoading) && <div className='px-6 w-full h-full bg-white overflow-hidden'> <SkeltonCardTwo arr={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]} height={20} className={'my-4'} /></div>}

                            {!isPoByIdLoading && poData ? <UpdatePo poData={poData} /> : <></>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
};